module.exports = __webpack_public_path__ + "img/back-hdtool.800eceaf.png";